import { posthog } from "posthog-js";

export function initPostHog(): void {
  const token = import.meta.env.VITE_POSTHOG_PROJECT_TOKEN as string | undefined;
  const host = import.meta.env.VITE_POSTHOG_HOST as string | undefined;
  if (!token) return;
  posthog.init(
    token,
    {
      api_host: host,
      capture_exceptions: true,
      autocapture: true,
      capture_pageview: true,
    },
    "2026-01-30",
  );
}

export function captureException(error: unknown): void {
  posthog.captureException(
    error instanceof Error ? error : new Error(String(error)),
  );
}

export { posthog };
